import { Box, Skeleton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { BoldSubHeaderText } from "../../styles/styledComponents/Header.styled";
import { IDailyCheckIn } from "../../services/daily-check-in/daily-check-in.interface";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { SecondaryButton } from "../../styles/styledComponents";
import { useDailyCheckIn } from "../../services/daily-check-in/daily-check-in.service";
import { userActivityLogger } from "../../utils/mixpanel";

const DailyCheckIn = () => {
  const { dailyCheckInData } = useDailyCheckIn();
  const [todaysCheckInData, setTodaysCheckInData] = useState<IDailyCheckIn>();


  const handleNavigate = () => {
    if (dailyCheckInData?.link) {
      userActivityLogger(MIXPANEL_EVENTS.DAILY_CHECK_IN, {});
      window.open(dailyCheckInData.link);
    }
  };

  useEffect(() => {
    setTodaysCheckInData(dailyCheckInData);
  }, [dailyCheckInData]);

  return (
    <>
      <Box>
        <BoldSubHeaderText className="!mb-3 capitalize">
          Daily Check-In
        </BoldSubHeaderText>
        {todaysCheckInData ? (
          <Box className="bg-white rounded-xl flex flex-col p-4 gap-2">
            <Box>
              <img src="/assets/icons/newUser2.png"
                className={"rounded-full overflow-hidden border border-blue-700 float-right"}
                alt="pet"
                style={{ width: "80px", height: "80px" }}
              />
              <Box>
                <BoldSubHeaderText className="!overflow-auto !whitespace-normal !text-wrap !mb-2" >
                  {todaysCheckInData?.header}
                </BoldSubHeaderText>
                <Typography className="!text-gray-1 !font-normal">
                  {todaysCheckInData?.description}
                </Typography>
              </Box>
            </Box>
            <SecondaryButton type={"button"} className="grow !text-xs font-semibold !py-2" onClick={handleNavigate}>
              Learn More
            </SecondaryButton>
          </Box>
        ) : (
          <Box className="h-full w-full justify-center items-center">
            <Skeleton variant="rectangular" className="rounded-xl !h-[1.5rem]"/>
          </Box>
        )}
      </Box>
    </>
  );
};

export default DailyCheckIn;
